import React, {useEffect, useMemo, useState} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFValue} from 'module/CustomField/type/CFType'
import Button from '@mui/material/Button'
import {getDqParamsObject} from 'module/CustomField/util/DqParam'
import {fetchDqAPI} from 'module/Dq/api/DqApi'
import {from, Subject, switchMap} from 'rxjs'
import {catchError, tap} from 'rxjs/operators'
import {log} from 'common/log'
import {bufferThrottleTime} from 'util/rxjsOperators/bufferThrottleTime'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {CF} from 'module/CustomField/util/CustomField'
import {css} from '@emotion/react'
import {parseDqResponseTO_deprecated} from 'module/Dq/util/DqParser'

const cssRoot = css`
	padding: 1px 6px;
`

export function CustomFieldLinkButtonComponent(props: CFComponentProps<CFValue>) {
	const {model, cfDef, pos} = props  // disabled not used, because the button should always be clickable!
	const [loading, setLoading] = useState(false)
	const click$ = useMemo(() => new Subject<Parameters<typeof fetchDqAPI>[0] & { target?: string }>(), [])
	useEffect(() => {
		const subscription = click$.pipe(
			tap(() => {
				setLoading(true)
			}),
			bufferThrottleTime(600),
			switchMap((x) => {
				const click = x[x.length - 1]
				if (!click) return []
				const {target} = click
				return from(fetchDqAPI(click)).pipe(
					tap((response) => {
						const {data} = response
						setLoading(false)
						//no parsing needed because only value is used
						data.elements.forEach(({value}) => {
							if (!value) return;
							const loc = (value + '').trim()
							if (loc) window.open(loc, target || '_blank')
						})
					}),
					catchError((err) => {
						log.error('Error in LinkButton-DQ-response:', err);
						setLoading(false)
						return []
					}),
				)
			}),
			catchError((err) => {
				log.error('LinkButton subscription aborted', err);
				setLoading(false)
				return []
			}),
		).subscribe()
		return () => subscription.unsubscribe()
	}, [click$])

	const onClick = () => {
		const params = getDqParamsObject(cfDef.dqParams, model, pos)
		click$.next({dqkey: cfDef.dqKey, params, filter: '', target: CF.getCFAttr(cfDef, CFAttrKey.openLinkTarget)?.value})
	}
	return <Button
		css={cssRoot}
		variant={'contained'}
		color={'primary'}
		disableElevation
		disabled={loading}
		onClick={onClick}
	>
		<span dangerouslySetInnerHTML={{__html: cfDef.label}}/>
	</Button>
}